import { ModelCategory, RoofContainer } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { TrussEnvelopeSchema } from './TrussEnvelopeSchema';

export const RoofContainerSchema = new ModelSchema<RoofContainer>('roofContainer', {
  category: ModelCategory.IntermediateModel,

  pluralName: 'Roof Containers',
  displayName: (container) => container.name,

  properties: {},
  children: {
    trussEnvelopes: TrussEnvelopeSchema,
  },
});
